<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">新闻管理</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label  DeviceInfos">
                <el-tabs>
                  <el-tab-pane label="添加新闻">
                    <el-form ref="form" :model="form" label-width="100px">
                      <el-form-item label="新闻标题：">
                        <el-input placeholder="请输入新闻标题" v-model="form.title"></el-input>
                      </el-form-item>

                      <el-form-item label="新闻分类：">
                        <el-select clearable v-model="form.cid" placeholder="选择新闻分类" class="news-select">
                          <el-option  v-for="(item, index) in type" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="新闻封面：" >
                          <el-upload
                            class="avatar-uploader"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                      </el-form-item>
                      <el-form-item label="新闻简介：" >
                        <el-input
                          class="textarea-ipt"
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 6}"
                          placeholder="请输入新闻简介"
                          v-model="form.introduction">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="新闻描述" ></el-form-item>
                      <quill-editor
                        v-model="form.content"
                        ref="myQuillEditor"
                        :options="quillOption"
                      >
                      </quill-editor>
                      <div class="h-30"></div>
                      <p class="Upload_pictures">
                          <span></span>
                          <span>建议单图上传5M以内产品图</span>
                      </p>
                       <div class="h-20"></div>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit(form)" size="medium">发布</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>
              <div class="h-30"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style>

  .ql-editor{height: 200px;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
// 富文本编辑器
import { quillEditor } from 'vue-quill-editor'
import quillConfig from '../../static/js/quill-config.js'
export default{
  data(){
    return {
     activeIndex: '3',
     imageUrl: '',
     type:{},
     form: {
         title: '',
         cid:'',
         content:'',
         picurl:'',
         introduction:'',
     },
     quillOption: quillConfig,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted(){
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberNews").then(res => {
          console.log(res);
           that.type= res.type;
          // this.loading = false
        });
    },


    // 图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.picurl = res.path;
    },
    //
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 <10;

        // if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        //   this.$message.error('上传头像图片只能是 JPG,jpeg,png 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return  isLt2M;
    },


    onSubmit(form){
      console.log(form);
      console.log(this.form.content);
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.form.userid = userid;
      console.log(this.form);
      that.$api.post("/Member/MemberNewsAdd",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
        that.form.title = '';
        that.form.cid = '';
        that.form.content = '';
        that.form.picurl = '';
        that.imageUrl="";
        that.moneystatus = false;
        that.checked = false;
      });
    },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberNewsAdd.vue